// extracted by mini-css-extract-plugin
export default {"page":"adminHome_page__idP4E","modules":"adminHome_modules__8TJfE","moduleItem":"adminHome_moduleItem__JYUhb","unread":"adminHome_unread__VIzH-"};